import { render } from "./StickyHeader.vue?vue&type=template&id=755b5e7c&scoped=true"
import script from "./StickyHeader.vue?vue&type=script&lang=js"
export * from "./StickyHeader.vue?vue&type=script&lang=js"

import "./StickyHeader.vue?vue&type=style&index=0&id=755b5e7c&lang=less&scoped=true"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755b5e7c"]])

export default __exports__